import data from './SUP.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function SUP() {

  return WithPage(data, "sup")

}

